// extracted by mini-css-extract-plugin
export default {"blockwrapper":"tO","header":"uO","name":"vO","columns":"wO","imagewrapper":"xO","addinfo":"yO","description":"zO","price":"AO","old":"BO","new":"CO","desc_d":"EO","infoblock":"FO","desc_m":"GO"};
    if(module.hot) {
      // 1713809678866
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  